import { mapJSONNode } from './mapJSONNode.js';
export const visitRef = (json, visitor, path = []) => {
    mapJSONNode(json, {
        ref: json => visitor(json.$ref, path),
        record: record => {
            for (const key in record)
                visitRef(record[key], visitor, [...path, key]);
        },
        array: list => {
            for (let i = 0; i < list.length; i++)
                visitRef(list[i], visitor, [...path, i]);
        }
    });
};
